import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Movie } from '../../services/Page/page.service';
import { BookingService } from '../../services/Booking/booking.service';
import { BackgroundVideoService } from '../../services/BackgroundVideo/background-video.service';
import { AddLargeComponent } from "../UI/add-large/add-large.component";
import { VideoPlayPauseButtonComponent } from "../video-play-pause-button/video-play-pause-button.component";
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-top-video',
    imports: [
        CommonModule,
        AddLargeComponent, VideoPlayPauseButtonComponent],
    templateUrl: './top-video.component.html',
    styleUrl: './top-video.component.scss'
})
export class TopVideoComponent {
    @ViewChild("videoEl") videoEl: ElementRef | undefined;

    @Input('isMobile') isMobile: boolean = false;
    @Input('movie')
    movie!: Movie;
    isAutoplayVideo: boolean = true

    constructor(
        public backgroundVideoService: BackgroundVideoService,
        public bookingService: BookingService,
    ) {

    }

    ngOnInit(): void {
        this.backgroundVideoService.isPlaying$.subscribe(isPlaying => {
            console.log('home page is Playing', isPlaying);
            if (this.isAutoplayVideo) {
                isPlaying ? this.videoEl?.nativeElement.play() : this.videoEl?.nativeElement.pause();
            }
            else {
                this.videoEl?.nativeElement.pause();
            }

        });
    }

        onBookNow() {
        // this.pageService.getMoviesByIds([this.topPromo[0].Dx]).then(movies 
        if(this.movie) {

            this.bookingService.open(this.movie) 
        }
    }
}
